export default __webpack_public_path__ + "60d1bd4a991ab3f599e76200bd3ceba1.svg";